import { BifrostLoader } from "@/Components/elements"
import { useEntriesV2 } from "@/Hooks"
import { useState } from "react"
import { useParams } from "react-router-dom"
import { Message } from "semantic-ui-react"
import BifrostModal from "../../../BifrostPageComponent/BifrostModal/BifrostModal"
import BifrostConfirmModalActions from "../../../BifrostPageComponent/BifrostModal/BifrostModalActions/BifrostConfirmModalActions"

const RemoveAllSubnetMappingsModal = ({ getDirectTunnelSubnetMapping }) => {
	const { id } = useParams()
	const [openModal, setOpenModal] = useState(false)
	const [removeAllSubnetMappingsState, { deleteData: removeAllSubnetMappings, reset }] = useEntriesV2(
		/* API endpoint to remove all subnet mappings for a specific direct tunnel by ID. */
		`/api/v2/device/directTunnel/${id}/ResetAllSubnetMappings`,
		/* OnSuccess callback to reset the state and close the modal. */
		() => {
			reset()
			setOpenModal(false)
			getDirectTunnelSubnetMapping()
		}
	)

	/**
	 * Handles the confirmation action for removing all subnet mappings.
	 * It triggers the API call to remove all subnet mappings and resets the state.
	 */
	const handleConfirm = () => removeAllSubnetMappings()

	/**
	 * Handles the cancellation action for the modal.
	 * It resets the state and closes the modal.
	 */
	const handleCancel = () => {
		reset()
		setOpenModal(false)
	}

	return (
		<BifrostModal
			title={"Remove All Subnet Mappings"}
			open={openModal}
			setOpen={() => setOpenModal(!openModal)}
			modalPage={
				<BifrostLoader backgroundColor="white" inverted height="1px" minHeight="20px" isLoading={removeAllSubnetMappingsState.isFetching}>
					{removeAllSubnetMappingsState.error ? (
						<Message negative>{removeAllSubnetMappingsState.error}</Message>
					) : (
						<Message negative>This action will delete all subnet mappings for the selected unit.</Message>
					)}
				</BifrostLoader>
			}
			trigger={
				<div
					onClick={() => setOpenModal(true)}
					style={{
						cursor: "pointer",
						color: "red",
						display: "flex",
						alignItems: "center"
					}}
				>
					- Remove All SubnetMappings
				</div>
			}
			modalActions={
				<BifrostConfirmModalActions
					isError={removeAllSubnetMappingsState.error}
					errorHandler={() => handleCancel()}
					loading={removeAllSubnetMappingsState.isFetching}
					confirmButtonColor="green"
					confirmText="Confirm"
					confirmHandler={() => handleConfirm()}
					cancelHandler={() => handleCancel()}
				/>
			}
		/>
	)
}

export default RemoveAllSubnetMappingsModal
